import { CommonEnums } from '../../common.enums';

export class CobolConverter_Inst {
    cobolConverter_Inst_Id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxFlow_Id: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    src_ConnNm: string;
    tgt_ConnNm: string;
    src_Conn_ValidCd: string;
    tgt_Conn_ValidCd: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.cobolConverter_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.disableFlg = CommonEnums.defaults.STRING_EMPTY;
        this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.src_Conn_ValidCd = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_Conn_ValidCd = CommonEnums.defaults.STRING_EMPTY;
        this.retryEnabled = CommonEnums.defaults.STRING_VAL_NO;
        this.numOfRetryAttempts = 2;
        this.retryWaitTime = 60;
    }

    copy(): CobolConverter_Inst {
        let cobolConverter_InstTmp: CobolConverter_Inst = new CobolConverter_Inst();

        cobolConverter_InstTmp.cobolConverter_Inst_Id = this.cobolConverter_Inst_Id;
        cobolConverter_InstTmp.nm = this.nm;
        cobolConverter_InstTmp.description = this.description;
        cobolConverter_InstTmp.ver = this.ver;
        cobolConverter_InstTmp.valid_Cd = this.valid_Cd;
        cobolConverter_InstTmp.dxFlow_Id = this.dxFlow_Id;
        cobolConverter_InstTmp.updateBy = this.updateBy;
        cobolConverter_InstTmp.lastUpdateBy= this.lastUpdateBy;
        cobolConverter_InstTmp.updateDt=this.updateDt;
        cobolConverter_InstTmp.disableFlg = this.disableFlg;
        cobolConverter_InstTmp.src_ConnNm = this.src_ConnNm;
        cobolConverter_InstTmp.tgt_ConnNm = this.tgt_ConnNm;
        cobolConverter_InstTmp.src_Conn_ValidCd = this.src_Conn_ValidCd;
        cobolConverter_InstTmp.tgt_Conn_ValidCd = this.tgt_Conn_ValidCd;
        cobolConverter_InstTmp.retryEnabled = this.retryEnabled;
        cobolConverter_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        cobolConverter_InstTmp.retryWaitTime = this.retryWaitTime;

        return cobolConverter_InstTmp;
    }

    copyFrom(cobolConverter_InstTmp: CobolConverter_Inst): void {
        this.cobolConverter_Inst_Id = cobolConverter_InstTmp.cobolConverter_Inst_Id;
        this.nm = cobolConverter_InstTmp.nm;
        this.description = cobolConverter_InstTmp.description;
        this.ver = cobolConverter_InstTmp.ver;
        this.valid_Cd = cobolConverter_InstTmp.valid_Cd;
        this.dxFlow_Id = cobolConverter_InstTmp.dxFlow_Id;
        this.updateBy = cobolConverter_InstTmp.updateBy;
        this.lastUpdateBy=cobolConverter_InstTmp.lastUpdateBy;
        this.updateDt=cobolConverter_InstTmp.updateDt;
        this.disableFlg = cobolConverter_InstTmp.disableFlg;
        this.src_ConnNm = cobolConverter_InstTmp.src_ConnNm;
        this.tgt_ConnNm = cobolConverter_InstTmp.tgt_ConnNm;
        this.src_Conn_ValidCd = cobolConverter_InstTmp.src_Conn_ValidCd;
        this.tgt_Conn_ValidCd = cobolConverter_InstTmp.tgt_Conn_ValidCd;
        this.retryEnabled = cobolConverter_InstTmp.retryEnabled;
        this.numOfRetryAttempts = cobolConverter_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = cobolConverter_InstTmp.retryWaitTime;
    }

    compare(cobolConverter_InstTmp: CobolConverter_Inst): string {
        let cobolConverter_InstString: string = this.toString(false);
        let cobolConverter_InstTmpString: string = cobolConverter_InstTmp.toString(false);

        if (cobolConverter_InstString != cobolConverter_InstTmpString) {
            return cobolConverter_InstString + ', ' + cobolConverter_InstTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "CobolConverter_Inst [cobolConverter_Inst_Id=" + this.cobolConverter_Inst_Id +
            ", nm=" + this.nm + ", description=" + this.description + ", valid_Cd=" + this.valid_Cd +
            ", dxFlow_Id=" + this.dxFlow_Id + ", disableFlg=" + this.disableFlg +
            ", ver=" + this.ver + ", updateBy=" + this.updateBy + ", updateDt=" + this.updateDt +
            ",retryEnabled =" + this.retryEnabled +
            ",numOfRetryAttempts =" + this.numOfRetryAttempts +
            ",retryWaitTime =" + this.retryWaitTime;
        if (isNotCompare) {
            str = ",  lastUpdateBy=" + this.lastUpdateBy +
                ", src_ConnNm=" + this.src_ConnNm +
                ", src_Conn_ValidCd=" + this.src_Conn_ValidCd +
                ", tgt_Conn_ValidCd=" + this.tgt_Conn_ValidCd +
                ", tgt_ConnNm=" + this.tgt_ConnNm;

        }

        str += ']';
        return str;
    }
}